const initialState = {
	isMobileMenuVisible: false,
	isHubspotFormVisible: false,
};

const TOGGLE_MENU = 'TOGGLE_MENU';
const TOGGLE_HUBSPOT_FORM = 'TOGGLE_HUBSPOT_FORM';

export const toggleMenu = isMobileMenuVisible => ({
	type: TOGGLE_MENU,
	isMobileMenuVisible,
});

export const toggleHubspotForm = isHubspotFormVisible => ({
	type: TOGGLE_HUBSPOT_FORM,
	isHubspotFormVisible,
});

export default (state = initialState, action = {}) => {
	if (action.type === TOGGLE_MENU) {
		return {
			...state,
			isMobileMenuVisible: action.isMobileMenuVisible,
		};
	}
	if (action.type === TOGGLE_HUBSPOT_FORM) {
		return {
			...state,
			isHubspotFormVisible: action.isHubspotFormVisible,
		};
	}
	return state;
};
